import React from "react";

export type OpenTrade = {
    symbol: string;
    entryPrice: number;
    amount: number;
    currentPrice: number;
    isBuy: boolean; // true = long, false = short
};

type OpenTradesProps = {
    trades: OpenTrade[];
};

export const OpenTradesBlock: React.FC<OpenTradesProps> = ({ trades }) => {

    const calcPnl = (t: OpenTrade) => {
        return t.isBuy
            ? (t.currentPrice - t.entryPrice) * t.amount   // long
            : (t.entryPrice - t.currentPrice) * t.amount;  // short
    };

    const calcRoe = (t: OpenTrade) => {
        return t.isBuy
            ? ((t.currentPrice - t.entryPrice) / t.entryPrice) * 100
            : ((t.entryPrice - t.currentPrice) / t.entryPrice) * 100;
    };

    return (
        <div className="bg-white shadow rounded-xl p-6 border border-gray-200">
            <h2 className="text-xl font-semibold mb-4">Открытые сделки</h2>

            {trades.length === 0 ? (
                <div className="text-gray-500 text-sm">Нет открытых позиций</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full text-sm">
                        <thead>
                            <tr className="border-b bg-gray-50">
                                <th className="py-3 px-2 text-left">Пара</th>
                                <th className="py-3 px-2 text-left">Тип</th>
                                <th className="py-3 px-2 text-left">Объём</th>
                                <th className="py-3 px-2 text-left">Цена</th>
                                <th className="py-3 px-2 text-left">Текущая цена</th>
                                <th className="py-3 px-2 text-left">Разница</th>
                            </tr>
                        </thead>

                        <tbody>
                            {trades.map((t, i) => {
                                return (
                                    <tr key={i} className="border-b">
                                        <td className="py-2 px-2 font-medium">{t.symbol}</td>

                                        <td className="py-2 px-2 font-semibold">
                                            {t.isBuy
                                                ? <span className="text-green-600">BUY</span>
                                                : <span className="text-red-600">SELL</span>
                                            }
                                        </td>

                                        <td className="py-2 px-2">{t.amount}</td>
                                        <td className="py-2 px-2">{t.entryPrice}</td>
                                        <td className="py-2 px-2">{t.currentPrice}</td>
                                        <td className="py-2 px-2 font-semibold text-red-600">{(t.isBuy ? t.currentPrice - t.entryPrice : t.entryPrice - t.currentPrice).toFixed(2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};